module.exports = __webpack_public_path__ + "media/pingo_doce.6cefc16d.mp3";